import React , {useState} from 'react';
import emailjs from 'emailjs-com';
import ReCAPTCHA from "react-google-recaptcha";

const RECAPTCHA_SITE_KEY = "6LeaOEosAAAAANUr0xNdbGkiKbMP-_kERUrzTFE2";

const Result = () => {
    return (
        <p className="success-message">Your Message has been successfully sent. I will contact you soon.</p>
    )
}

function ContactForm({props , formStyle}) {
    const [ result,showresult ] = useState(false);
    const [ captchaValue,setCaptchaValue ] = useState(null);

    const sendEmail = (e) => {
        e.preventDefault();
        if (!captchaValue) {
            alert("Please complete the reCAPTCHA before submitting.");
            return;
        }
        emailjs
        .sendForm(
            'service_7yyrafb', 
            'template_nsldnyl', 
            e.target, 
            'mh2NzoQE6vH5s5-zI'
        )
        .then((result) => {
            console.log(result.text);
            }, 
            (error) => {
                console.log(error.text);
            }
        );
        e.target.reset();
        setCaptchaValue(null);
        showresult(true);
    };

    setTimeout(() => {
        showresult(false);
    }, 5000);

    return (
        <form className={`${formStyle}`} action="" onSubmit={sendEmail}>
            <div className="form-group">
                <input 
                id="fullname"
                type="text"
                name="fullname"
                placeholder="Your Name"
                aria-label="Your full name"
                required
                />
            </div>

            <div className="form-group">
                <input 
                id="email"
                type="email"
                name="email"
                placeholder="Email Address"
                aria-label="Email address"
                required
                />
            </div>

            <div className="form-group">
                <input 
                id="phone"
                type="text"
                name="phone"
                placeholder="Phone Number"
                aria-label="Phone number"
                required
                />
            </div>


            <div className="form-group">
                <input 
                id="subject"
                type="text"
                name="subject"
                placeholder="Subject"
                aria-label="Subject of your message"
                required
                />
            </div>

            <div className="form-group">
                <textarea 
                id="message"
                name="message"
                placeholder="Your Message"
                aria-label="Your message content"
                required
                >
                </textarea>
            </div>
            <div className="form-group">
                <ReCAPTCHA
                    sitekey={RECAPTCHA_SITE_KEY}
                    onChange={(value) => setCaptchaValue(value)}
                />
                <input
                    type="hidden"
                    name="g-recaptcha-response"
                    value={captchaValue || ""}
                    aria-hidden="true"
                />
            </div>

            <div className="form-group">
                <button type="submit" className="btn-default btn-large">Submit Now</button>
            </div> 

            <div className="form-group" role="status" aria-live="polite">
                {result ? <Result /> : null}
            </div> 
        </form>
    )
}
export default ContactForm;
